import Box from '@mui/material/Box'
import LinearProgress from '@mui/material/LinearProgress'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import { useState } from 'react'
import { RcTrans } from '@/components/atoms/RcTrans'
import { ModalConfiguration } from '@/components/organisms/modal/ModalConfiguration'
import { useCompetitionActions } from '@/entity/competition/useCompetitionActions'

export const TeamReindex = ({
  selected,
  onComplete
}: {
  selected: number[]
  onComplete: () => void
}) => {
  const { reindexTeam } = useCompetitionActions()
  const [completed, setCompleted] = useState(0)
  const [errors, setErrors] = useState<string[]>([])

  const reindex = async () => {
    const errorList: string[] = []

    await Promise.allSettled(
      selected.map(async item => {
        try {
          await reindexTeam(item)
        } catch (error: any) {
          errorList.push(`Error reindexing team ${item}: ${error.message}`)
        } finally {
          setCompleted(i => i + 1)
        }
      })
    )

    setErrors(errorList)
  }

  const progress = (completed / selected.length) * 100

  return (
    <>
      <Stack direction='column' spacing={1}>
        {errors.map((error, index) => (
          <Box key={index}>{error}</Box>
        ))}
      </Stack>
      <ModalConfiguration
        title={<RcTrans i18nKey='competition:team.reindex-title' />}
        subtitle={<RcTrans i18nKey='competition:team.reindex-description' />}
      >
        {progress === 100 ? (
          <Button fullWidth onClick={onComplete}>
            <RcTrans i18nKey='competition:team.reindex-complete' />
          </Button>
        ) : progress > 1 ? (
          <LinearProgress
            variant='determinate'
            value={progress}
            sx={{ borderRadius: 25, height: 35 }}
          />
        ) : (
          <Button onClick={reindex} fullWidth>
            <RcTrans
              i18nKey='competition:team.reindex-button'
              tOptions={{ count: selected.length }}
            />
          </Button>
        )}
      </ModalConfiguration>
    </>
  )
}
